// extracted by mini-css-extract-plugin
module.exports = {"error":"list-files_error_1NPVC","table":"list-files_table_2xiFV","textDivider":"list-files_textDivider_3UJnu","textDividerContent":"list-files_textDividerContent_3A1w0"};